import React, { useState, useEffect } from "react";
import { FiUsers, FiCalendar } from "react-icons/fi";
import { useAuth } from "../../contexts/AuthContext";
import { useData } from "../../contexts/DataContext";
import { format, isPast } from "date-fns";

// Safe date converter (handles Firestore Timestamps)
const toDate = v => { if(!v) return new Date(); if(typeof v?.toDate==="function") return v.toDate(); return new Date(v); };





const COLORS = ["#054bb4","#059669","#7c3aed","#d97706","#dc2626","#0284c7"];

export default function StudentGroups() {
  const { userData } = useAuth();
  const { getGroups } = useData();
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { getGroups({ classId: userData?.class }).then(d => { setGroups(d); setLoading(false); }); }, []);

  return (
    <div className="fade-in">
      <div className="page-head">
        <div><h1 className="page-title">👥 My Groups</h1><p className="page-subtitle">Collaborative group work assignments</p></div>
      </div>
      {loading ? <div className="loading-center"><div className="spinner" /></div> :
        groups.length === 0 ? (
          <div className="card"><div className="empty-state"><div className="empty-icon">👥</div><div className="empty-title">No groups yet</div><div className="empty-desc">Your teacher hasn't assigned you to any groups yet.</div></div></div>
        ) : (
          <div className="g g2">
            {groups.map((g, i) => {
              const clr = COLORS[i % COLORS.length];
              const over = g.deadline && isPast(toDate(g.deadline));
              return (
                <div key={g.id} className="card"
                  onMouseEnter={e => e.currentTarget.style.boxShadow = "0 4px 14px rgba(0,0,0,.08)"}
                  onMouseLeave={e => e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,.06)"}>
                  <div style={{ height: 3, background: clr }} />
                  <div style={{ padding: "14px 16px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
                      <div style={{ width: 40, height: 40, borderRadius: "var(--r8)", background: clr + "15", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <FiUsers size={18} style={{ color: clr }} />
                      </div>
                      <div>
                        <h4 style={{ fontSize: ".95rem", fontWeight: 700 }}>{g.name}</h4>
                        <div style={{ display: "flex", gap: 6, marginTop: 3 }}>
                          <span className="badge badge-blue" style={{ fontSize: ".67rem" }}>{g.subject}</span>
                          <span className="badge badge-gray" style={{ fontSize: ".67rem" }}>{g.memberCount || g.members?.length || 0} members</span>
                        </div>
                      </div>
                    </div>
                    <div style={{ background: "var(--gray-50)", borderRadius: "var(--r6)", padding: "10px 12px", marginBottom: 12, borderLeft: `3px solid ${clr}` }}>
                      <div style={{ fontSize: ".7rem", fontWeight: 700, color: clr, marginBottom: 4 }}>TASK</div>
                      <div style={{ fontSize: ".84rem", color: "var(--gray-700)", lineHeight: 1.55 }}>{g.task}</div>
                    </div>
                    <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 12 }}>
                      {(g.members || []).slice(0, 5).map((m, mi) => (
                        <div key={mi} className="avatar av-sm" title={typeof m === "string" ? m : (m?.name || "")}
                          style={{ background: `hsl(${mi*70},60%,88%)`, color: `hsl(${mi*70},60%,30%)`, fontSize: ".65rem" }}>
                          {(typeof m === "string" ? m : (m?.name || "")).split(" ").map(n => n[0]).join("").slice(0, 2)}
                        </div>
                      ))}
                      {(g.members || []).length > 5 && (
                        <div className="avatar av-sm" style={{ background: "var(--gray-100)", color: "var(--gray-500)", fontSize: ".65rem" }}>
                          +{g.members.length - 5}
                        </div>
                      )}
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: ".75rem", color: "var(--gray-500)" }}>
                      <span>By {g.teacherName}</span>
                      {g.deadline && (
                        <span style={{ color: over ? "var(--red-600)" : "var(--amber-600)", fontWeight: 600, display: "flex", alignItems: "center", gap: 4 }}>
                          <FiCalendar size={11} /> {over ? "Overdue" : format(toDate(g.deadline), "MMM d")}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
    </div>
  );
}
